import { SubscriptionAvailabilityModel } from './../models/subscriptionavailabilityrestriction.model';
import { SubscriptionService } from './../../sharedvehiclegroupsubscription/models/sharedvehiclegroupsubscription.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { DataListModel } from './../../shared/config';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, IKeyValueInterface, ApplicationRouteURL } from '../../shared/config';
import { Location } from '@angular/common';

@Component({
  selector: 'wego-subscriptionavailabilityrestriction-update',
  template: require('../views/subscriptionavailabilityrestriction-update.component.html'),
  providers: [SubscriptionService],
})

export class SubscriptionaAvailabilityUpdateComponent implements OnInit, OnDestroy {

  sub: any;
  model: SubscriptionAvailabilityModel;
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlSubscriptionAvailablityList: string;
  errorMessage: string;
  DataListModel: DataListModel;
  defaultContractypeGroupList: any;
  urlSubscriptionAvailabilityList: string;
  urlSVGList:string;
  sharedvehicleGroup: string;
  dayofWeekList: any;
  subscriptionHashId:string;
  subscriptionAvailabilityHashId:string;
  sharedVehicleGroupHashId:string;
  urlSubscriptionList:string;
  subscriptionList:string;


  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;

  @ViewChild('successPopup') public successPopup: any;

  constructor(private subscriptionService: SubscriptionService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private locationService: Location) {
  }

  ngOnInit() {
    this.dayofWeekList = [
      {
        Key:'Sunday',
        Value: '0',
      },
      {
        Key: 'Monday',
        Value: '1',
      },
       {
        Key: 'Tuesday',
        Value: '2',
      },
       {
        Key: 'Wednesday',
        Value: '3',
      },
       {
        Key: 'Thursday',
        Value:'4',
      },
       {
        Key: 'Friday',
        Value: '5',
      },
      {
        Key: 'Saturday',
        Value: this.translate.instant('6'),
      }];

    this.module = this.translate.instant('LblSubscriptionAvailabilityRestriction');
    this.sharedvehicleGroup = this.translate.instant('LblListPage', this.translate.instant('LblSharedVehicleGroup'));
    this.subscriptionList=this.translate.instant('LblListPage',this.translate.instant('LblSubscription'))
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlSubscriptionAvailabilityList = this.authService.GetURL(ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_LIST);
    this.urlSVGList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.urlSubscriptionList=this.authService.GetURL(ApplicationRouteURL.URL_SUBSCRIPTION_LIST);
    this.model = new SubscriptionAvailabilityModel();
    this.isEditMode = false;
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.subscriptionHashId = params['sharedVehicleGroupSubscriptionHashId'] || '';
        this.subscriptionAvailabilityHashId = params['subscriptionAvailabiltiyHashId'] || '';
        this.sharedVehicleGroupHashId=params['sharedVehicleGroupHashId'];

        if(this.subscriptionAvailabilityHashId!='')
        {
            this.GetSubscriptionAvailabilityByHashId();
        }
        if (this.subscriptionHashId != '') {
        this.model.sharedVehicleSubscriptionHashId= this.subscriptionHashId;
        this.model.startDay=this.dayofWeekList[0].Value;
        this.model.endDay=this.dayofWeekList[0].Value;
        }
        
      });
    
    this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
  }
 onSubmit(forms: any) {
    console.log(this.model);
    this.AddSubScriptionAvailability();
  }

  public AddSubScriptionAvailability() {
    this.subscriptionService.AddSubscriptionAvailability(this.model)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.isEditMode ? this.translate.instant('LblRecordUpdatedSuccess', [this.module]) : this.translate.instant('LblRecordAddedSuccess', [this.module]);
          this.ShowSuccessPopup();
        }
        else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      });
  }
  public GetSubscriptionAvailabilityByHashId()
  {
        if (this.subscriptionAvailabilityHashId != '') {
          this.isEditMode = true;
          this.subscriptionService.GetSubscriptionAvailabilityRestrictionByHashId(this.subscriptionAvailabilityHashId)
            .subscribe(
            res => {
              this.model = res.data;
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
            });
        }
  }
  public SuccessModalClick(): void {
    this.successPopup.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/subscriptionavailabilityrestriction/components/subscriptionavailabilityrestriction-update.component.ts